export default {
  home: {
    realtime_trace: '实时轨迹',
    history_trace: '历史轨迹',
    unit: '固定监测',
    vehicle: '移动监测',
    new_ex: '最新异常',
    carrier_normal_abnormal: '资产正常/异常',
    welcome: '欢迎使用',
    protect: '已为您保驾护航',
    recent_stat: '近况统计',
    probe_equi: '探测设备',
    filter: '过滤器',
    no_range: '无监测区间',
    record_info: '记录信息',
    range: '区间',
    greater: '大于',
    less: '小于',
    plan: '平面图',
    please_enter_carrier: '请输入资产名称',
    summary: '概述',
    carrier_status: '资产状态',
    handle_num: '处理数',

    // 引导的标题
    home_ex: '如何处理异常',
    history_data: '如何查看历史数据',
    alarm_switch: '如何启动/关闭报警',
    print_data: '如何打印数据',
    transport_code: '如何查看运输码',
    export_data: '如何导出数据',

    not_found_plan:'请先关联平面图',
    plan_map_home:'平面图/地图实况',
    device_home:'设备实况',
    carrier_home:'资产实况',
    open_org:'展开组织架构',
    hide_org:'收缩组织架构',
    show_org:'组织架构节点',
    handle_reason_required: '处理原因不能为空',
    handle_person_required: '处理人不能为空',
    handle_length_limit: '长度为30以内',
    custom: '自定义',

    // 仪表盘相关
    dashboard: {
      location_map: '位置地图',
      dynamic_assets: '动态资产',
      loading_assets: '加载资产中...',
      no_assets_found: '未找到资产',
      view_details: '查看详情',
      device_ratio: '设备比例',
      abnormal_ratio: '异常比例',
      offline_ratio: '离线比例',
      device_status: '设备状态',
      online: '在线',
      abnormal: '异常',
      offline: '离线',
      recent_events: '最近事件',
      view_all: '查看全部',
      environmental_trends: '环境趋势',
      trend_range_7d: '7天',
      trend_range_15d: '15天',
      trend_range_30d: '30天',
      export_data: '导出数据',
      temperature_distribution: '温度分布',
      humidity_distribution: '湿度分布',
      normal: '正常',
      loading_map: '加载地图中...',
      total_assets: '总资产',
      static_assets: '静态资产',
      dynamic_assets_label: '动态资产',
      total_alarms: '总告警',
      device_offline: '设备离线',
      device_power_outage: '设备断电',
      temperature_alert: '温度告警',
      humidity_alert: '湿度告警',
      lost_connection: '失去连接',
      exceeded_threshold: '超出阈值',
      power_outage: '断电',
      no_description: '无描述',
      just_now: '刚刚',
      min_ago: '分钟前',
      hour_ago: '小时前',
      day_ago: '天前',
      unknown: '未知',
      organization: '组织架构',
      dashboard: '仪表盘',
      real_time_monitoring: '实时监控',
      customer_no_location_title: '提示',
      customer_no_location_message: '当前客户没有定位，将尝试获取您的当前位置',
      current_location: '当前位置',
      default_location: '默认位置',
      view_history_trace: '查看历史轨迹',
      online_devices: '在线设备',
      warning_devices: '告警设备',
      danger_devices: '危险设备',
      vehicles: '运输车辆',
      no_recent_alerts: '暂无最近告警',
      unknown_carrier: '未知载体',
      s_ago: '秒前',
      m_ago: '分钟前',
      h_ago: '小时前',
      d_ago: '天前'
    }
  }
}
